import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  max-width: ', ';\n  padding: 50px 20px;\n  @media (max-width: ', ') {\n    padding: 10px 20px;\n  }\n'], ['\n  margin: 0 auto;\n  max-width: ', ';\n  padding: 50px 20px;\n  @media (max-width: ', ') {\n    padding: 10px 20px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 50px;\n  width: 100%;\n  position: relative;\n  margin: 3em auto 0;\n  max-width: 600px;\n\n  &::before {\n    opacity: 0;\n    content: \'\';\n    left: 0;\n    background-color: ', ';\n    position: absolute;\n    top: -50px;\n    width: 100%;\n    z-index: -1;\n    height: 50px;\n\n    ', '\n  }\n'], ['\n  height: 50px;\n  width: 100%;\n  position: relative;\n  margin: 3em auto 0;\n  max-width: 600px;\n\n  &::before {\n    opacity: 0;\n    content: \'\';\n    left: 0;\n    background-color: ', ';\n    position: absolute;\n    top: -50px;\n    width: 100%;\n    z-index: -1;\n    height: 50px;\n\n    ', '\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n        animation: ', ' 0.7s;\n        opacity: 1;\n      '], ['\n        animation: ', ' 0.7s;\n        opacity: 1;\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: 50px;\n  position: relative;\n'], ['\n  height: 50px;\n  position: relative;\n']);

import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import CartDrawerHeader from '../components/CartDrawerHeader/CartDrawerHeader';
import LineItemList from '../components/LineItemList/LineItemList';
// import CartDrawerSwymCta from '../components/CartDrawerSwymCta/CartDrawerSwymCta';
import DonateADollar from '../components/DonateADollar/DonateADollar';
import CartFaq from '../components/CartFaq/CartFaq';

import { getCartItems } from '../Utils/CartUtils';

import { StyledNoProducts } from '../components/CartDrawer/CartDrawerStyles';

var StyledDiv = styled.div(_templateObject, function (props) {
  return props.theme.siteWidth;
}, function (props) {
  return props.theme.mobileWidth;
});

var StyleButtonWrapper = styled.div(_templateObject2, function (props) {
  return props.theme.dormifyWhite;
}, function (_ref) {
  var isCartOpen = _ref.isCartOpen;
  return isCartOpen && css(_templateObject3, fadeInDelay);
});

var StyledButton = styled.button(_templateObject4);

var openCheckout = function openCheckout(webUrl) {
  // Strip the domain to use same domain as present
  var relativeUrl = webUrl.replace('https://dormifyplus.myshopify.com', '');
  window.location.href = relativeUrl;
};

var _ref2 = React.createElement(
  StyledNoProducts,
  null,
  'Oops! Nothing here yet, but let\u2019s change that'
);

var _ref3 = React.createElement(CartFaq, null);

var CartPage = function CartPage(props) {
  var lineItems = props.checkout.lineItems.edges;
  var checkoutNote = props.checkout.note;
  var checkoutCustomAttributes = props.checkout.customAttributes;

  var isDonateProductInCart = false;
  if (props.donateADollarPromo && props.donateADollarProduct) {
    isDonateProductInCart = lineItems.some(function (item) {
      return item.node.title === props.donateADollarProduct.title;
    });
  }

  return React.createElement(
    StyledDiv,
    null,
    React.createElement(CartDrawerHeader, {
      checkout: props.checkout,
      items: lineItems,
      webUrl: props.checkout.webUrl,
      cartQuantity: props.cartQuantity,
      noVendorItems: getCartItems(lineItems, 'VENDOR').length === 0,
      addPlusReleaseDate: props.addPlusReleaseDate,
      addCheckoutNote: props.addCheckoutNote,
      addDiscountCode: props.addDiscountCode,
      removeDiscountCode: props.removeDiscountCode,
      checkoutNote: checkoutNote,
      checkoutDiscountCodes: props.checkout.discountApplications,
      checkoutCustomAttributes: checkoutCustomAttributes,
      autoDiscountPromo: props.autoDiscountPromo,
      autoDiscountCode: props.autoDiscountCode,
      autoDiscountCodeEndDate: props.autoDiscountCodeEndDate,
      discountThresholdAmount: props.discountThresholdAmount
    }),
    lineItems.length > 0 ? React.createElement(
      Fragment,
      null,
      React.createElement(LineItemList, {
        title: 'Ships In 24-48 Hours',
        subTitle: 'ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'WAREHOUSE'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In 5-8 Business Days',
        subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'VENDOR'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      })
    ) : _ref2,
    props.donateADollarPromo === true && !isDonateProductInCart && React.createElement(DonateADollar, {
      donateADollarProduct: props.donateADollarProduct,
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout
    }),
    React.createElement(
      StyleButtonWrapper,
      { isCartOpen: false },
      React.createElement(
        StyledButton,
        {
          className: 'btn btn--full gradient-shimmer',
          disabled: props.cartQuantity === 0,
          onClick: function onClick() {
            return openCheckout(props.checkout.webUrl);
          }
        },
        'Proceed To Checkout'
      )
    ),
    _ref3
  );
};

CartPage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  updateCartQuantity: PropTypes.func.isRequired,
  removeLineItemInCart: PropTypes.func.isRequired,
  updateLineItemInCart: PropTypes.func.isRequired,
  addCheckoutNote: PropTypes.func.isRequired,
  addPlusReleaseDate: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  cartQuantity: PropTypes.number.isRequired,
  shipLaterEnabled: PropTypes.bool,
  handleCartClose: PropTypes.func.isRequired,
  donateADollarPromo: PropTypes.bool,
  donateADollarProduct: PropTypes.object,
  addDiscountCode: PropTypes.func,
  removeDiscountCode: PropTypes.func,
  autoDiscountPromo: PropTypes.bool,
  autoDiscountCode: PropTypes.string,
  autoDiscountCodeEndDate: PropTypes.string,
  discountThresholdAmount: PropTypes.string
};

export default CartPage;